import React from 'react'
import * as R from 'ramda'
import {dataURItoBlob} from 'utils/stuff'

export default (o) => {
	let type = o.file && o.file.type || ''
	let link = o.link || ""
	let name = o.name || ""
	let href = o.href || ""
return(
	((!o.file || typeof o.file != "object") && !link)?
		<div style={o.style} className={o.className}>Loading</div>
		:(
			~name.indexOf('jpeg')
		 || ~name.indexOf('png')
		 || ~name.indexOf('jpg')
		 || ~type.indexOf('image')
		)?
			<span title={name} className={o.className} style={o.style}>
				<img
					src={(link)? link : (o.file && !R.equals(o.file, {}))? URL.createObjectURL(o.file): ''}
					style={o.attachmentStyle}
					alt={name}
					onClick={o.onClick}
					title={name}
				/>
				{(o.deleteFunction)?
					<i
						className="material-icons delete-attachment-icon"
						onClick={o.deleteFunction}
					>
						clear
					</i>
					: ''
				}
			</span>
			:(~type.indexOf('pdf') || ~href.indexOf('pdf'))?
				<span className={o.className} style={o.style}>
					<a
						onClick={o.onClick}
						style={{
							textDecoration: 'none'
							, color: 'inherit'
							, display: 'inline-block'
							, cursor: 'pointer'
						}}
						title={name}
					>
						{(o.thumb)?
							<span
								style={{
									cursor: "pointer"
								 ,paddingRight: "12px"
								}}
							>
								PDF
							</span>
						:
							<iframe
								src={(href)? href : URL.createObjectURL(o.file)}
								style={{
									width: "600px"
								, maxWidth: "100%"
								, position: "absolute"
								, top: "0"
								, right: "0"
								, bottom: "0"
								, left: "0"
								, height: "1024px"
								, maxHeight: "90%"
								, margin: "auto"
								}}
							/>
						}
					</a>
					{(o.deleteFunction)?
						<i
							className="material-icons delete-attachment-icon"
							onClick={o.deleteFunction}
						>
							clear
						</i>
						: ''
					}
				</span>
			:(~name.indexOf('mp3') || ~type.indexOf('audio'))?
				<span className={o.className} style={o.style}>
					<a
						onClick={o.onClick}
						style={{
							textDecoration: 'none'
						  , color: 'inherit'
						  , display: 'inline-block'
						  , cursor: 'pointer'
						}}
					>
						{(o.thumb)?
							<i
								style={o.attachmentStyle}
								className="material-icons"
							>
								play_circle_outline
							</i>
						:
							<audio
								style={o.attachmentStyle}
								controls
							>
								<source
									src={(link)? link :(o.file && !R.equals(o.file, {}))? URL.createObjectURL(o.file): ''}
									type={type}
								/>
								Тег audio не поддерживается вашим браузером.
							</audio>
						}
					</a>
					{(o.deleteFunction)?
						<i
							className="material-icons delete-attachment-icon"
							onClick={o.deleteFunction}
						>
							clear
						</i>
						: ''
					}
				</span>
				:(~name.indexOf('video') || ~type.indexOf('video'))?
					<span className={o.className} style={o.style}>
						<a
							onClick={o.onClick}
							style={{
								textDecoration: 'none'
							  , color: 'inherit'
							  , display: 'inline-block'
							  , cursor: 'pointer'
							}}
						>
							{(o.thumb)?
								<i
									style={{
										fontSize: '40px',
										...o.attachmentStyle
									}}
									className="material-icons"
								>
									play_circle_outline
								</i>
							:
								<video
									style={o.attachmentStyle}
									controls
								>
									<source
										src={(link)? link :(o.file && !R.equals(o.file, {}))? URL.createObjectURL(o.file): ''}
										type={type}
									/>
									Your browser does not support the video tag.
								</video>
							}
						</a>
						{(o.deleteFunction)?
							<i
								className="material-icons delete-attachment-icon"
								onClick={o.deleteFunction}
							>
								clear
							</i>
							: ''
						}
					</span>
					:<span title={name} className={o.className} style={o.style}>
						<a
							onClick={o.onClick}
							style={{
								textDecoration: 'none'
							  , color: 'inherit'
							  , border: '1px solid black'
							  , display: 'inline-block'
							  , height: 'inherit'
							  , lineHeight: '31px'
							  , fontSize: '12px'
							  , padding: '3px'
							  , cursor: 'pointer'
							  , ...o.attachmentStyle
							}}
						>
							{`*.${name.split('.')[name.split('.').length - 1]}`}
						</a>
						{(o.deleteFunction)?
							<i
								className="material-icons delete-attachment-icon"
								onClick={o.deleteFunction}
							>
								clear
							</i>
							: ''
						}
					</span>
)}



// WEBPACK FOOTER //
// ./src/components/AttachmentRender.js